// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__Em_Rp","emails":"CreateEditClinics_emails__q2DwG","emailTagLabel":"CreateEditClinics_emailTagLabel__T6Z2C"};